import React from "react";
import AllAds from "../components/admin/AllAds";

function AllAdsPage(props) {
  return <AllAds props={props} />;
}

export default AllAdsPage;
